import React, { useEffect } from 'react'
import * as echarts from 'echarts'

const Rose = function ({
  id,
  data = [],
  width,
  height,
  name = '',
  showLegend = true,
  showLabel = true,
  showTooltip = true,
  legend = {},
  colors = ['#5B8FF9', '#5AD8A6', '#945FB9', '#F6BD16', '#E86452'],
  formatter = '{a} <br/>{b} : {c} ({d}%)',
  radius = [90, 120],
  right = 0,
  roseType = false,
  label = {},
  title,
  onClick = () => {},
}) {
  useEffect(() => {
    const chartDom = document.getElementById(id)
    const myChart = echarts.init(chartDom)
    myChart.setOption({
      title,
      color: colors,
      tooltip: {
        show: showTooltip,
        trigger: 'item',
        formatter,
      },
      legend: { show: showLegend, ...legend },
      series: [
        {
          name,
          label: {
            show: showLabel,
            ...label,
          },
          type: 'pie',
          roseType,
          radius,
          center: ['50%', '50%'],
          data,
          right,
        },
      ],
    })
    myChart.on('click', (params) => {
      onClick(params)
    })
  }, [id, data])
  return <div id={id} style={{ width, height }} />
}

export default Rose
